import { ActionType } from 'typesafe-actions';
import { put, select, takeEvery } from 'redux-saga/effects';

import { IOkved } from 'APIPackage/KnmModule/interfaces/IOkved';
import { fetchRegistryExportOkved } from 'APIPackage/KnmModule/services/knmRegistryApi';
import { sagaWrapper } from 'CorePackage/MainModule/common/sagaWrapper';

import {
  registryExportOkvedGet,
  registryExportOkvedGetRequest,
  registryExportOkvedGetSuccess,
  registryExportOkvedGetFailure,
} from '../actions/registryActions';
import { RegistryActionsEnum } from '../enums/RegistryActionsEnum';
import { RegistryStatusesEnum } from '../enums/RegistryStatusesEnum';
import { IRegistryExportOkvedFilterParams } from '../interfaces/IRegistryExportOkvedFilterParams';
import { getRegistryExportOkvedItemStatus } from '../selectors/registrySelectors';

export function* watchRegistrySaga() {
  yield takeEvery(RegistryActionsEnum.REGISTRY_EXPORT_OKVED_GET, registryExportOkvedGetHandler);
}

function* registryExportOkvedGetHandler(action: ActionType<typeof registryExportOkvedGet>) {
  const { filterParams } = action.payload;
  const status: RegistryStatusesEnum = yield select(getRegistryExportOkvedItemStatus, filterParams);

  if (!status || status === RegistryStatusesEnum.IDLE) {
    yield fetchRegistryExportOkvedSaga(filterParams);
  }
}

function* fetchRegistryExportOkvedSaga(filterParams: IRegistryExportOkvedFilterParams) {
  function* funcTry() {
    yield put(registryExportOkvedGetRequest(filterParams));
    const okveds: IOkved[] = yield fetchRegistryExportOkved(filterParams.inn, filterParams.ogrn);

    yield put(registryExportOkvedGetSuccess(filterParams, okveds));
  }
  function* funcCatch() {
    yield put(registryExportOkvedGetFailure(filterParams));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}
